<!-- Validation Email success -->
<div class="modal-register visible" *ngIf="validationEmail">
  <div class="validation-success-card-modal">
    <button type="button" class="validation-success-close" aria-label="Close" (click)="closeRegister()">
      <img src="../../../../assets/images/register-asset/close.svg" alt="icon close">
    </button>

    <div class="validation-success-header-modal">
      <img src="../../../../assets/images/logo-header-shell.svg" alt="Shell Box"
        class="validation-success-logo-modal" />
      <h2 class="validation-success-title-modal">Te damos la bienvenida</h2>
    </div>
    <div class="validation-success-body-modal">
      <div>
        <p class="validation-success-subtitle-modal"><b>Ya validamos tu cuenta.</b></p>
        <p class="validation-success-desc-modal">
          Ahora sí, ingresá a Shell Box y empezá a disfrutar todos los beneficios.
        </p>
      </div>

      <button class="validation-success-btn-modal" (click)="closeRegister()" data-gtm-id="id_ok_register">Entendido</button>
    </div>
  </div>
</div>




<div [ngClass]="isModal?'modal-register':''" >
  <div class="container" *ngIf="!confirmRegister">
    <div class="register-container">
      <div class="register card">
        <button type="button" *ngIf="isModal" class="btn-close register-close" aria-label="Close" (click)="closeRegister()"></button>
        <div class="title-register">
          <img src="../../../../assets/images/logo-header-shell.svg" alt="">
          <h2>Registrate en Shell Box y empezá a disfrutar de todos los beneficios</h2>
        </div>
        <form class="register-form" [formGroup]="registerForm" (ngSubmit)="register()">
          <div>
            <p class="title-step">Datos personales</p>
            <div class="mt-2">
              <label for="register-documento" class="form-label">DNI</label>
              <input
                type="number"
                maxlength="8"
                pattern="[0-9]*"
                class="form-control register-form-input"
                id="register-documento"
                (blur)="onDocumentBlur()"
                formControlName="registerDocumento"
                placeholder="Ingresá tu número de DNI"
                [ngClass]="{
                  invalid:
                    registerForm.get('registerDocumento')?.invalid &&
                    registerForm.get('registerDocumento')?.touched ||
                    documentExist
                }"
              />
              <div
                *ngIf="registerForm.get('registerDocumento')?.errors && registerForm.get('registerDocumento')?.touched"
                class="error-message"
              >
                <span
                  *ngIf="registerForm.get('registerDocumento')?.errors?.['required']"
                  >El DNI es obligatorio.</span
                >
                <span
                  *ngIf="registerForm.get('registerDocumento')?.errors?.['pattern']"
                  >El DNI debe contener entre 7 u 8 dígitos.</span
                >
                <span
                  *ngIf="registerForm.get('registerDocumento')?.errors?.['maxlength']"
                  >El DNI no puede tener más de 8 dígitos.</span
                >
              </div>
              <div *ngIf="documentExist" class="error-message">
                Este DNI ya esta asociado a una cuenta Shell Box. <a href="/ingresar">Iniciá sesión</a> o ingresá otro DNI para registrarte.
              </div>
            </div>
        
            <div class="mt-2">
              <label for="register-nombre" class="form-label">Nombre</label>
              <input
                type="text"
                id="register-nombre"
                class="form-control register-form-input"
                placeholder="Ingresá tu nombre"
                formControlName="registerNombre"
                [ngClass]="{
                  invalid:
                    registerForm.get('registerNombre')?.invalid &&
                    registerForm.get('registerNombre')?.touched
                }"
              />
              <div
                *ngIf="registerForm.get('registerNombre')?.errors?.['required'] && registerForm.get('registerNombre')?.touched"
                class="error-message"
              >
                El nombre es obligatorio.
              </div>
            </div>
        
            <div class="mt-2">
              <label for="register-apellido" class="form-label">Apellido</label>
              <input
                type="text"
                id="register-apellido"
                class="form-control register-form-input"
                placeholder="Ingresa tu apellido"
                formControlName="registerApellido"
                [ngClass]="{
                  invalid:
                    registerForm.get('registerApellido')?.invalid &&
                    registerForm.get('registerApellido')?.touched
                }"
              />
              <div
                *ngIf="registerForm.get('registerApellido')?.errors?.['required'] && registerForm.get('registerApellido')?.touched"
                class="error-message"
              >
                El apellido es obligatorio.
              </div>
            </div>
        
            <div class="mt-2">
              <label for="register-nacimiento" class="form-label"
                >Fecha de nacimiento</label
              >
              <input
                [type]="isDateFocused ? 'date' : 'text'"
                id="register-nacimiento"
                class="form-control register-form-input"
                placeholder="dd/mm/aaaa"
                formControlName="registerNacimiento"
                [ngClass]="{
                  invalid:
                    registerForm.get('registerNacimiento')?.invalid &&
                    registerForm.get('registerNacimiento')?.touched
                }"
                (focus)="isDateFocused = true"
                (blur)="onDateBlur()"
              />            
              <div
                *ngIf="registerForm.get('registerNacimiento')?.errors?.['required'] && registerForm.get('registerNacimiento')?.touched"
                class="error-message"
              >
                La fecha de nacimiento es obligatoria.
              </div>
              <div
                *ngIf="registerForm.get('registerNacimiento')?.errors?.['underEighteen'] && registerForm.get('registerNacimiento')?.touched"
                class="error-message"
              >
                Debes ser mayor de 18 años para registrarte.
              </div>
            </div>
          </div>
        
          <div class="register-form mt-4">
            <p class="title-step">Datos de contacto</p>
            <div class="mt-2 div-container-numero">
              <div class="div-cod-area">
                <label for="register-cod-area" class="form-label">Cód.Area</label>
                <input
                  type="text"
                  maxlength="4"
                  class="form-control register-form-input"
                  id="register-cod-area"
                  [ngClass]="{
                    invalid:
                      registerForm.get('registerCodArea')?.invalid &&
                      registerForm.get('registerCodArea')?.touched
                  }"
                  placeholder="Ej.264"
                  formControlName="registerCodArea"
                />
                <div
                  *ngIf="registerForm.get('registerCodArea')?.errors?.['required'] && registerForm.get('registerCodArea')?.touched"
                  class="error-message"
                >
                  El código de área es obligatorio.
                </div>
              </div>
              <div class="div-numero-telefono">
                <label for="register-numero-telefono" class="form-label">Celular</label>
                <input
                  type="text"
                  maxlength="10"
                  class="form-control register-form-input"
                  id="register-numero-telefono"
                  [ngClass]="{
                    invalid:
                      registerForm.get('registerNumeroTelefono')?.invalid &&
                      registerForm.get('registerNumeroTelefono')?.touched
                  }"
                  placeholder="Ingresá tu celular sin 0 y sin 15"
                  formControlName="registerNumeroTelefono"
                />
                <div
                  *ngIf="registerForm.get('registerNumeroTelefono')?.errors?.['required'] && registerForm.get('registerNumeroTelefono')?.touched"
                  class="error-message"
                >
                  El número de celular es obligatorio.
                </div>
              </div>
            </div>
        
            <div class="mt-2">
              <label for="register-email" class="form-label">E-mail</label>
              <input
                type="email"
                id="register-email"
                class="form-control register-form-input"
                [ngClass]="{
                  invalid:
                    registerForm.get('registerEmail')?.invalid &&
                    registerForm.get('registerEmail')?.touched || emailExist
                }"
                placeholder="Ingresá tu e-mail"
                (blur)="onEmailBlur()"
                formControlName="registerEmail"
                autocomplete="off"
              />
              <div
                *ngIf="registerForm.get('registerEmail')?.errors?.['required'] && registerForm.get('registerEmail')?.touched"
                class="error-message"
              >
                El e-mail es obligatorio.
              </div>
              <div
                *ngIf="registerForm.get('registerEmail')?.errors?.['email'] && registerForm.get('registerEmail')?.touched"
                class="error-message"
              >
                E-mail inválido. Por favor, ingresa una dirección de correo válida.
              </div>
              <div
                *ngIf="emailExist"
                class="error-message"
              >
                Este e-mail ya esta asociado a una cuenta Shell Box. <a href="/ingresar">Iniciá sesión</a> o ingresá otro correo para registrarte.
              </div>
            </div>
        
            <div class="mt-2">
              <label for="register-confirmar-email" class="form-label"
                >Repetí el e-mail</label
              >
              <input
                type="email"
                id="register-confirmar-email"
                class="form-control register-form-input"
                [ngClass]="{
                  invalid:
                    registerForm.get('registerConfirmarEmail')?.invalid &&
                    registerForm.get('registerConfirmarEmail')?.touched
                }"
                placeholder="Ingresá nuevamente tu e-mail"
                formControlName="registerConfirmarEmail"
                (copy)="preventCopyPaste($event)"
                (paste)="preventCopyPaste($event)"
                (cut)="preventCopyPaste($event)"
                (dragstart)="preventCopyPaste($event)"
                (drop)="preventCopyPaste($event)"
                (contextmenu)="preventCopyPaste($event)"
              />
              <div
                *ngIf="registerForm.get('registerConfirmarEmail')?.errors?.['required'] && registerForm.get('registerConfirmarEmail')?.touched"
                class="error-message"
              >
                Confirma tu e-mail.
              </div>
              <div
              *ngIf="registerForm.errors?.['emailMismatch'] && registerForm.get('registerConfirmarEmail')?.touched"
              class="error-message"
              >
                El e-mail no coincide. Revisa e intentá de nuevo.
              </div>            
            </div>
          </div>
        
          <div class="register-form mt-4">
            <p class="title-step">Contraseña</p>
            <div class="mt-2">
              <label for="register-password" class="form-label"
                >Creá una contraseña</label
              >
              <div class="wrap-password">
                <input
                  [type]="!showpass1 ? 'password' : 'text'"
                  id="register-password"
                  class="form-control register-form-input"
                  [ngClass]="{
                    invalid:
                      (registerForm.get('registerPassword')?.errors?.['weakPassword'] ||
                       registerForm.get('registerPassword')?.errors?.['required']) &&
                      registerForm.get('registerPassword')?.touched
                  }"
                  placeholder="Ingresá tu contraseña"
                  formControlName="registerPassword"
                />
                <span
                  class="eye"
                  [ngClass]="showpass1 ? 'show' : ''"
                  (click)="showpass1 = !showpass1"
                ></span>
              </div>
              <app-password-requirements class="mt-2" [control]="registerForm.get('registerPassword')" ></app-password-requirements>             
            </div>
        
            <div class="mt-3">
              <label for="register-password2" class="form-label"
                >Repetí la contraseña</label
              >
              <div class="wrap-password">
                <input
                  [type]="!showpass2 ? 'password' : 'text'"
                  id="register-password2"
                  class="form-control register-form-input"
                  [ngClass]="{
                    invalid:
                      (registerForm.get('registerPassword')?.errors?.['weakPassword'] ||
                       registerForm.get('registerPassword')?.errors?.['required']) &&
                      registerForm.get('registerPassword')?.touched
                  }"
                  placeholder="Ingresá tu contraseña nuevamente"
                  formControlName="registerConfirmPassword"
                  (copy)="preventCopyPaste($event)"
                  (paste)="preventCopyPaste($event)"
                  (cut)="preventCopyPaste($event)"
                  (dragstart)="preventCopyPaste($event)"
                  (drop)="preventCopyPaste($event)"
                  (contextmenu)="preventCopyPaste($event)"
                />
                <span
                  class="eye"
                  [ngClass]="showpass2 ? 'show' : ''"
                  (click)="showpass2 = !showpass2"
                ></span>
              </div>
              <div
              *ngIf="registerForm.errors?.['passwordMismatch'] && registerForm.get('registerConfirmPassword')?.touched"
              class="error-message"
            >
              Las contraseñas no coinciden. Revisalas e intentá de nuevo.
            </div>
            
            </div>
        
            <div class="mt-4 checkbox-options">
              <input
                id="register-quiero-recibir-novedades"
                type="checkbox"
                formControlName="registerRecibirNovedades"
              />
              <label
                for="register-quiero-recibir-novedades"
                class="form-label register-light"
                >Quiero recibir novedades y promociones de Shell Box</label
              >
            </div>
        
            <div class="mt-1 checkbox-options">
              <input
                id="register-acepto-terminos"
                data-gtm-id="register-acepto-terminos"
                type="checkbox"
                formControlName="registerTerminosCondiciones"
              />
              <label
                for="register-acepto-terminos"
                class="form-label register-light"
                >He leído y acepto los
                <a href="assets/terminos-y-condiciones.pdf" target="_blank"
                  >términos y condiciones</a
                ></label
              >
              <div
                *ngIf="registerForm.get('registerTerminosCondiciones')?.errors?.['requiredTrue'] && registerForm.get('registerTerminosCondiciones')?.touched"
                class="error-message"
              >
                Debes aceptar los términos y condiciones.
              </div>
            </div>
        
            <div class="mt-1 checkbox-options">
              <input
                id="register-acepto-terminos-market"
                data-gtm-id="register-acepto-terminos-market"
                type="checkbox"
                formControlName="registerTerminosCondicionesMarketShell"
              />
              <label
                for="register-acepto-terminos-market"
                class="form-label register-light"
                >He leído y acepto los
                <a
                  href="https://central-content.portal-movilidad.simplitec.io/assets/6f5eab68-778d-46b0-8a5c-8cc289daebce"
                  target="_blank"
                  >términos y condiciones de Market Shell</a
                ></label
              >
            </div>
          </div>
        
          <div class="register-form mt-4">
            <button
              [disabled]="registerForm.invalid || registerIn || emailExist || documentExist"
              id="userConfirmRegister"
              [ngClass]="registerIn ? 'loading' : ''"
              class="btn btn-register"
              type="submit"
            >
              <ng-container *ngIf="registerIn; else normalText">
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              </ng-container>
              <ng-template #normalText> Registrarme </ng-template>
            </button>
            <input
              class="btn-close-modal mt-3"
              (click)="closeRegister()"
              type="button"
              value="Cancelar"
            />
          </div>
        </form>
      </div>
    </div>
  </div>


  <app-confirm-register 
    *ngIf="confirmRegister" 
    [userEmail]="this.f.registerEmail.value"
    (close)="onCloseConfirmRegister()" 
  ></app-confirm-register>

</div>